module.exports = __webpack_public_path__ + "static/flags/KV-d8feb4769d340a87b098b32c22f54425.gif";